import { create } from 'jss'
import { jssPreset } from '@material-ui/core/styles'

/**
 * Pins MUI v4's stylesheets to a fixed place in `<head>` so v5 always wins.
 *
 * Both libraries emit the same global class names (`MuiButton-containedPrimary`),
 * but only v4 attaches styles to them — v5's live on an emotion class of equal
 * specificity. So whichever sheet is appended last wins, and since both inject
 * lazily on first mount, that flips with the route you arrive by: the same sprint
 * header renders a purple Edit and a grey Delete on one load, a blue Edit and a
 * red Delete on the next.
 *
 * Call this *after* the app's own stylesheets have been imported. The insertion
 * point then sits behind them, which leaves Tailwind ahead of v4 exactly as it is
 * today — `injectFirst` would instead hoist v4 above Tailwind and change which one
 * wins on the many v4 components carrying raw `className`s.
 */
export function createV4Jss() {
  const insertionPoint = document.createElement('style')
  insertionPoint.setAttribute('data-jss-insertion-point', '')
  document.head.appendChild(insertionPoint)

  return create({ ...jssPreset(), insertionPoint })
}
